import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/** Shared loading / error treatment for one Home region (specs/home-page §7). */
export const getHomeRegionStateStyles = (theme: Theme) =>
  StyleSheet.create({
    errorWrap: {
      flex: 1,
      minHeight: 72,
      borderRadius: theme.borderRadius.xl,
      backgroundColor: theme.background.card,
      paddingHorizontal: 12,
      paddingVertical: 10,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 8,
    },
    errorTitle: {
      flex: 1,
      minWidth: 0,
      fontSize: 12,
      fontWeight: '700',
      color: theme.gray[500],
    },
    retryButton: {
      height: 30,
      paddingHorizontal: 10,
      borderRadius: theme.borderRadius.sm,
      backgroundColor: theme.background.inset,
      justifyContent: 'center',
      alignItems: 'center',
    },
    retryButtonPressed: {
      opacity: 0.7,
    },
    retryButtonHover: {
      opacity: 0.85,
    },
    retryText: {
      fontSize: 11,
      fontWeight: '800',
      color: theme.primary,
    },
    skeletonStack: {
      gap: 8,
    },
    skeletonRow: {
      height: 42,
      borderRadius: theme.borderRadius.md,
      backgroundColor: theme.background.inset,
      opacity: 0.6,
    },
    skeletonTile: {
      flex: 1,
      minHeight: 52,
      borderRadius: 14,
      backgroundColor: theme.background.card,
      opacity: 0.6,
    },
  });
